import type { WithActiveBranchId } from '../shared';

export enum AiBusinessAnalyticsEndpoints {
  AnalyzeBusinessData = 'AnalyzeBusinessData',
}

export type AnalyzeBusinessDataRequest = WithActiveBranchId<{
  data: {
    query: string;
    file?: File;
  };
}>;

export interface AnalyzeBusinessDataResponse {
  Success: boolean;
  Answer: string;
  Provider: string | null;
  Model: string | null;
  InputTokens: number | null;
  OutputTokens: number | null;
  Error: string | null;
}
